/* eslint-disable */
import React, { useState } from 'react';
import p from './devsPop.module.css';
import { Ic } from './devsIcons';
import { fmt } from './devsBarModel';

// DevsOptionList — the checkbox list of one axis: search-within when there are more than 6 options,
// the faceted count beside each (zero is dimmed, never hidden), "Only" on hover/focus.
// A chosen value that left the vocabulary stays in the list (it never vanishes from under the pointer).
export default function DevsOptionList({ axis, name, options, selected, counts, ready, onToggle, onOnly, autoFocus }) {
  const [ls, setLs] = useState('');
  const sel = new Set(selected);
  const voc = options.concat(selected.filter((v) => !options.some((o) => o.value === v)).map((v) => ({ value: v, label: v })));
  const q = ls.trim().toLowerCase();
  const items = voc.filter((o) => !q || String(o.label).toLowerCase().includes(q));
  return (
    <>
      {voc.length > 6 && (
        <div className={p.ls}>
          <Ic n="srch" />
          <input type="search" placeholder={`Find ${name.toLowerCase()}…`} value={ls} onChange={(e) => setLs(e.target.value)} aria-label={`Find ${name}`} autoComplete="off" autoFocus={autoFocus} data-nav />
        </div>
      )}
      <div className={p.opts} role="group" aria-label={name}>
        {items.map((o) => {
          const on = sel.has(o.value), n = ready ? (counts && counts[o.value]) ?? 0 : null;
          return (
            <div key={o.value} className={`${p.opt} ${on ? p.on : ''} ${n === 0 ? p.zero : ''}`}>
              <button type="button" className={p.ob} aria-pressed={on} title={o.label} data-nav onClick={() => onToggle(axis, o.value)}>
                <i className={p.cb}>{on ? <Ic n="chk" /> : null}</i><span className={p.ol}>{o.label}</span><span className={p.oc}>{fmt(n)}</span>
              </button>
              <button type="button" className={p.only} aria-label={`Only ${o.label}`} onClick={() => onOnly(axis, o.value)}>Only</button>
            </div>
          );
        })}
        {!items.length && <div className={p.none}>Nothing matches “{ls}”</div>}
      </div>
    </>
  );
}
